import { render, staticRenderFns } from "./General.vue?vue&type=template&id=fd0939da&"
import script from "./General.vue?vue&type=script&lang=js&"
export * from "./General.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd0939da')) {
      api.createRecord('fd0939da', component.options)
    } else {
      api.reload('fd0939da', component.options)
    }
    module.hot.accept("./General.vue?vue&type=template&id=fd0939da&", function () {
      api.rerender('fd0939da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Settings/General.vue"
export default component.exports